import * as React from "react";
import { Box } from "@quandoo-dev/cookbook/lib/layout";
import { Document } from "@contentful/rich-text-types";
import { Heading } from "@quandoo-dev/cookbook/lib/typography";
import { getLevelFromPriceCategory } from "../../utils/price-category";
import PriceCategory from "./price-category";
import RichText from "../rich-text";
import Button from "@quandoo-dev/cookbook/lib/button";
import Address, { IAddress } from "./address";
import OpeningHours from "./opening-hours";
import { OpeningHour } from "../../utils/opening-hours";
import InstagramEmbed from "./instagram-embed";
import Img, { FluidObject } from "gatsby-image";
import SectionTitle from "./section-title";

interface EmbedProps {
  merchantName: string;
  priceCategory: string;
  linkToBook: string;
  richDescription: { json: Document };
  instagramPostUrl?: string;
  merchantImage?: { fluid: FluidObject };
  ctaText: string;
  address?: IAddress;
  addressText?: string;
  openingHours?: OpeningHour[];
  staticImage: any;
  country;
  customSectionTitle?: string;
  customSectionText?: { json: Document };
}

const MerchantEmbed: React.FC<EmbedProps> = ({
  merchantName,
  priceCategory,
  richDescription,
  linkToBook,
  address,
  addressText,
  openingHours,
  instagramPostUrl,
  merchantImage,
  ctaText,
  staticImage,
  country,
  customSectionTitle,
  customSectionText,
}) => {
  const level = getLevelFromPriceCategory(priceCategory);

  return (
    <Box>
      <Heading size={3} mb="xs">
        {merchantName}
      </Heading>
      {Boolean(level) && <PriceCategory level={level} />}
      {instagramPostUrl && <InstagramEmbed url={instagramPostUrl} />}
      {!instagramPostUrl && merchantImage && (
        <Box mt="xs" mb="lg">
          {merchantImage.fluid ? (
            <Img fluid={merchantImage.fluid} alt={merchantName} />
          ) : (
            <img src={staticImage} />
          )}
        </Box>
      )}
      <RichText document={richDescription ? richDescription.json : null} />
      <Box mt="xl" mb="xxl">
        <Button as="a" variation="secondary" href={linkToBook}>
          {ctaText}
        </Button>
      </Box>
      {customSectionTitle && (
        <SectionTitle
          letterSpacing="1px"
          fontSize="body.sm"
          fontWeight="semibold"
          style={{ marginBottom: "8px" }}
        >
          {customSectionTitle}
        </SectionTitle>
      )}
      <RichText document={customSectionText ? customSectionText.json : null} />
      {address && (
        <Address address={address} text={addressText} country={country} />
      )}
      {openingHours && openingHours.length && (
        <OpeningHours openingHours={openingHours} country={country} />
      )}
    </Box>
  );
};

export default MerchantEmbed;
